import { Check } from "lucide-react";

const WhatYouGet: React.FC = () => {
  const features = [
    "Complete referral system with unique codes generation",
    "Automated commission processing & payouts (cron jobs)",
    "Stripe Connect integration for affiliate payouts",
    "Admin dashboard to manage affiliates and payments",
    "Referral link sharing and tracking",
    "Real-time earnings dashboard for affiliates",
    "Full Prisma schema and API routes",
    "TypeScript throughout the codebase",
    "Built with Next.js 14 App Router",
    "Responsive UI with Tailwind CSS"
  ];

  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
          What's Included
        </h2>

        <p className="text-xl text-cyan-400 font-semibold mb-8 text-center">
          Everything you need to launch your referral program:
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-8">
          {features.map((item, index) => (
            <div key={index} className="flex items-start space-x-3 bg-gray-900 p-4 rounded-lg">
              <Check className="text-cyan-400 flex-shrink-0 mt-1" size={20} />
              <span className="text-gray-200 sm:text-lg text-sm">{item}</span>
            </div>
          ))}
        </div>

        <p className="mt-2 text-center text-lg text-gray-300 font-medium">
          This is the exact system running on PeerQuik. Production-tested and ready to paste into your code.
        </p>
      </div>
    </section>
  );
};

export default WhatYouGet;
